<template>
  <div
    v-if="account"
    class="account-card-modern"
  >
    <div class="account-header">
      <span class="account-title">{{ account.name }}</span>
      <span class="account-type">{{ account.account_name }}</span>
    </div>

    <div class="account-number-box">
      <span style="word-break: break-all; flex: 1;">{{ account.number }}</span>

      <div
        class="copy-btn-modern"
        @click="copyNumber"
      >
        Copy
      </div>
    </div>

    <div class="account-note-modern">
      {{ account.note }}
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "AccountCard",

  props: {
    account: {
      type: Object,
      required: false,
      default: null,
    },
  },

  methods: {
    copyNumber() {
      if (!this.account || !this.account.number) return;

      navigator.clipboard.writeText(this.account.number);
      Toast.success("Copied");
    },
  },
};
</script>

<style scoped>
.account-card-modern {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 16px;
  border-radius: 15px;
  margin-top: 20px;
  color: #fff;
  backdrop-filter: blur(6px);
}

.account-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.account-title {
  font-size: 16px;
  font-weight: 600;
}

.account-type {
  font-size: 12px;
  opacity: 0.8;
}

.account-number-box {
  margin-top: 12px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.copy-btn-modern {
  background: linear-gradient(135deg, #5A4BFF, #A557FF);
  padding: 6px 16px;
  border-radius: 10px;
  font-size: 14px;
  color: white;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.copy-btn-modern:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.account-note-modern {
  font-size: 12px;
  opacity: 0.8;
  margin-top: 10px;
}
</style>
